import { takeLatest } from 'redux-saga/effects';
import {
  getUploadsIfNeeded,
  getUsageTypeTagsIfNeeded,
  createUploadIfNeeded,
  updateUploadIfNeeded,
  deleteUploadIfNeeded
} from './sagas';
import {
  GET_UPLOADS,
  GET_USAGE_TYPE_TAGS,
  CREATE_UPLOAD,
  UPDATE_UPLOAD,
  DELETE_UPLOAD
} from './actions';

function* watchGetUploads() {
  yield takeLatest(GET_UPLOADS, getUploadsIfNeeded);
}

function* watchGetUsageTypeTags() {
  yield takeLatest(GET_USAGE_TYPE_TAGS, getUsageTypeTagsIfNeeded);
}

function* watchCreateUpload() {
  yield takeLatest(CREATE_UPLOAD, createUploadIfNeeded);
}

function* watchUpdateUpload() {
  yield takeLatest(UPDATE_UPLOAD, updateUploadIfNeeded);
}

function* watchDeleteUpload() {
  yield takeLatest(DELETE_UPLOAD, deleteUploadIfNeeded);
}

export default [
  watchGetUploads,
  watchGetUsageTypeTags,
  watchCreateUpload,
  watchUpdateUpload,
  watchDeleteUpload
];